<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Personal Information">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label">First Name </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.childsFirstName"
                />
                <ErrorLabel field="custom.childsFirstName" />
              </div>
              <div style="width: 100%">
                <FormLabel class="control-label"> Last Name </FormLabel>
                <FormInput type="text" class="width-full" field="custom.childsLastName" />
                <ErrorLabel field="custom.childsLastName" />
              </div>
            </FormRow>

            <FormRow inline>
              <GenderPicker />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>  
            <FormRow inline>
              <div style="width: 100%">
                <FormCol field="School">
                  <FormSelect field="custom.schoolName">
                    <option value=""></option>
                    <option value="BPY">BPY</option>
                    <option value="Haftr">Haftr</option>
                    <option value="Halb">Halb</option>
                    <option value="Hanc">Hanc</option>
                    <option value="Heatid">Heatid</option>
                    <option value="Kushner">Kushner</option>
                    <option value="Moriah">Moriah</option>
                    <option value="Magen David">Magen David</option>
                    <option value="Manhattan Day School">Manhattan Day School</option>
                    <option value="Noam">Noam</option>
                    <option value="Yeshiva Of Flatbush">Yeshiva Of Flatbush</option>
                    <option value="Yavneh (LA)">Yavneh (LA)</option>
                  </FormSelect>
                </FormCol>
                <ErrorLabel field="custom.schoolName" />
              </div>
              <div style="width: 100%">
                <FormCol field="custom.birthDate" width="full" :showLabel="false">
                  <label class="control-label">Birthdate </label>
                  <input
                    type="date"
                    class="date-input"
                    @change="setDailyDate(new Date($event.target.value))"
                  />
                </FormCol>
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <DonorAddress />
          </FormSection>
          <FormSection title="Media Release Form">
            <ParentsReleaseWaiver organization="All Mishnah Jr" />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, setValue, getValue, submit } = usePaymentForm();

    const currency = ref(form.value.currency);

    // Guard to prevent infinite DatePicker loop
    let isSettingDate = false;

    onMounted(() => {
      setValue("amount", "90");
    });

    return {
      form,
      currency,
      setValue,
      getValue,
      submit,
      setDailyDate(date: Date) {
        if (isSettingDate) return;
        isSettingDate = true;

        setValue(
          "custom.birthDate",
          new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
          ).toISOString()
        );

        setTimeout(() => {
          isSettingDate = false;
        }, 100);
      },

    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

::v-deep label.control-label {
  flex: 1;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  font-size: 14px;
  color: #222;
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}
</style>
